module.exports = __webpack_public_path__ + "img/dimequest-compass-wire.2ddd4b77.png";